import React, { Component } from 'react';
import { Grid, Form, Button, Divider } from 'semantic-ui-react';
import { changePassword, changeUserPassword } from '../../utils/rest';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import { NotificationManager } from 'react-notifications';
const initialState = {
    usrId: 0,
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
};

class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;
    }

    componentDidMount() {
        this.props.addItem("helpFile", "acct_change-password.md");
        this.props.addItem("corporateSelect", false);
        this.setState({
            usrId: this.props.usrId
        });
    }

    componentWillUnmount() {
        this.props.addItem("corporateSelect", true);
        this.props.addItem("helpFile", null);
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    onReset = (e) => {
        e.preventDefault();
        this.setState(initialState);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { usrId, oldPassword, newPassword, confirmPassword } = this.state;
        if (newPassword.length > 0 && confirmPassword.length > 0) {
            if (newPassword === confirmPassword) {
                if (usrId > 0) {
                    changeUserPassword({
                        param: usrId,
                        body: {
                            usrPassword: newPassword
                        },
                    }).then(response => {
                        if (response !== null) {
                            this.props.modalClose();
                            NotificationManager.success('Success', 'Password updated successfully.');
                            this.setState(initialState);
                        }
                    });
                } else {
                    changePassword({
                        usrPassword: newPassword,
                        usrOldPassword: oldPassword
                    }).then(response => {
                        if (response !== null) {
                            NotificationManager.success('Success', 'Password updated successfully.');
                            this.setState(initialState);
                        }
                    });
                }
            } else {
                NotificationManager.error('error', 'Passwords do not match.');
            }
        }

    }

    handleResetLink = (e) => {
        e.preventDefault();
        changeUserPassword({
            param: this.state.usrId,
            body: {
                usrPassword: null
            },
        }).then(response => {
            if (response !== null) {
                this.props.modalClose();
                NotificationManager.success('Success', 'Password reset link sent successfully.');
                this.setState(initialState);
            }
        });
    }

    conditionalRender = () => {
        if (this.props.usrId > 0) {
            return (
                <Form className="small">
                    <Form.Group>
                        <Form.Field width={4}>
                            <Form.Input label='New Password:' required={true} className="required" placeholder='New Password' type="password" name="newPassword" onChange={this.onChange} value={this.state.newPassword} />
                        </Form.Field>
                        <Form.Field width={4}>
                            <Form.Input label='Confirm New Password:' required={true} className="required" placeholder='Confirm New Password' type="password" name="confirmPassword" onChange={this.onChange} value={this.state.confirmPassword} />
                        </Form.Field>
                        <Form.Field width={4}>
                            <Button.Group className="small push-down">
                                <Button onClick={this.onReset}>{this.props.t("reset")}</Button>
                                <Button.Or />
                                <Button positive onClick={this.handleSubmit}>{this.props.t("submit")}</Button>
                            </Button.Group>
                        </Form.Field>
                    </Form.Group>
                    <Divider horizontal>OR</Divider>
                    <Form.Group>
                        <Form.Field width={16} style={{ textAlign: "center" }}>
                            <Button positive onClick={this.handleResetLink}>{this.props.t("reset.link")}</Button>
                        </Form.Field>
                    </Form.Group>
                </Form>
            );
        } else {
            return (
                <Form className="small">
                    <Form.Group>
                        <Form.Field width={4}>
                            <Form.Input label='Old Password:' required={true} className="required" placeholder='Old Password' type="password" name="oldPassword" onChange={this.onChange} value={this.state.oldPassword} />
                        </Form.Field>
                        <Form.Field width={4}>
                            <Form.Input label='New Password:' required={true} className="required" placeholder='New Password' type="password" name="newPassword" onChange={this.onChange} value={this.state.newPassword} />
                        </Form.Field>
                        <Form.Field width={4}>
                            <Form.Input label='Confirm New Password:' required={true} className="required" placeholder='Confirm New Password' type="password" name="confirmPassword" onChange={this.onChange} value={this.state.confirmPassword} />
                        </Form.Field>
                        <Form.Field width={4}>
                            <Button.Group className="small push-down">
                                <Button onClick={this.onReset}>{this.props.t("reset")}</Button>
                                <Button.Or />
                                <Button positive onClick={this.handleSubmit}>{this.props.t("submit")}</Button>
                            </Button.Group>
                        </Form.Field>
                    </Form.Group>
                </Form>
            );
        }

    }
    render() {
        return (
            <div>
                {this.props.usrId > 0 ? "" : <BreadcrumbCustom {...this.props} parent="My Account" child={[{ name: "Change Password", url: null }]} />}
                <Grid className={this.props.usrId > 0 ? "" : "g-bkgd"}>
                    <Grid.Row>
                        <Grid.Column>
                            {this.conditionalRender()}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div >
        );
    }
}
export default ChangePassword;


// WEBPACK FOOTER //
// ./src/app/ui/administrations/ChangePassword.js